import Card from "./card.js";
export default class CaptionedImage extends Card {
  constructor(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f) {
    super(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f),
      (this.U = "ab-captioned-image"),
      (this.V = !0),
      (this.test = !1);
  }
  ss() {
    const t = {};
    return (
      (t[Card.hs.ts] = Card.es.tt),
      (t[Card.hs.ns] = this.id),
      (t[Card.hs.ls] = this.viewed),
      (t[Card.hs.st] = this.title),
      (t[Card.hs.os] = this.imageUrl),
      (t[Card.hs.it] = this.description),
      (t[Card.hs.us] = this.updated),
      (t[Card.hs.cs] = this.created),
      (t[Card.hs.bs] = this.categories),
      (t[Card.hs.ds] = this.expiresAt),
      (t[Card.hs.URL] = this.url),
      (t[Card.hs.ps] = this.linkText),
      (t[Card.hs.fs] = this.aspectRatio),
      (t[Card.hs.xs] = this.extras),
      (t[Card.hs.gs] = this.pinned),
      (t[Card.hs.js] = this.dismissible),
      (t[Card.hs.ys] = this.clicked),
      (t[Card.hs.zs] = this.test),
      t
    );
  }
}
